import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: false
})
@Injectable()
export class StripHtmlPipe implements PipeTransform {
  public transform(text: string): string {
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.body.textContent || '';
  }
}
